window.cpap.onDocumentReady(() => {
  window.cpap = window.cpap || {};
  window.cpap.mulberry = window.cpap.mulberry || {};

  let offers;
  let product;

  async function mulberryInit() {
    if (typeof window.mulberryShop === 'undefined' || !window.mulberryShop.getProductData) {
      window.cpap.logError('mulberryShop is not defined or missing required methods.');
      return;
    }

    try {
      const productData = await window.mulberryShop.getProductData(
        window.mulberryShop.getProductUrl()
      );
      product = productData?.product;

      if (!product || !Array.isArray(product.variants)) {
        window.cpap.logError('Product data is invalid or missing variants for Mulberry.');
        return;
      }

      async function getOffers() {
        try {
          const productData = await window.mulberryShop.getProductData(
            window.mulberryShop.getProductUrl()
          );

          product = productData.product;
          window.mulberryShop.selectedVariantId = window.selectedVariantId;
          window.selectedVariant = product.variants.find(
            (i) => i.id == window.mulberryShop.selectedVariantId
          );

          if (!window.selectedVariant) {
            window.selectedVariant = product.variants[0];
          }

          if (window.selectedVariant && window.selectedVariant.id && window.selectedVariant.price) {
            return window.mulberry.core.getWarrantyOffer({
              detail: product,
              title: product.title,
              id: window.selectedVariant.id,
              price: window.selectedVariant.price,
            });
          }
        } catch (error) {
          window.cpap.logError(error, {
            sentry__additionalData: {
              Mulberry: 'Error fetching warranty offers',
            },
          });
          return [];
        }
      }

      offers = await getOffers();

      if (!offers || offers.length === 0) {
        window.cpap.logError('No offers available', {
          sentry__additionalData: {
            Mulberry: 'No offers available',
          },
        });
        return;
      }

      const modalOverlayNode = document.querySelector('.mulberry-modal-overlay');
      if (modalOverlayNode) {
        document.querySelector('.mulberry-modal-overlay').textContent = ` `;
      }

      await window.mulberry.inline.init({
        offers,
        settings: window.mulberry.core.settings,
        selector: '#mulberry-container',
        onWarrantyToggle: async (warranty) => {
          try {
            console.log('warranty toggled', warranty);
            if (warranty.isSelected) {
              window.selectedWarranty = warranty;
              window.productForWarranty = product;
            } else {
              window.selectedWarranty = null;
              window.productForWarranty = null;
              Shopify.getCart(function (cart) {
                window.mulberryShop.removeDetachedWarranty(cart);
              });
            }
          } catch (error) {
            window.cpap.logError(error, {
              sentry__additionalData: {
                Mulberry: 'Error toggling warranty',
              },
            });
          }
        },
      });

      const modalInlineOverlayNode = document.querySelector('.mulberry-modal--inline');
      if (modalInlineOverlayNode) {
        modalInlineOverlayNode.textContent = ` `;
      }

      const modalModalOverlayNode = document.querySelector('.mulberry-modal-overlay');
      if (modalModalOverlayNode) {
        modalModalOverlayNode.textContent = ` `;
      }
    } catch (error) {
      window.cpap.logError(error, {
        sentry__additionalData: {
          Mulberry: 'Error initializing Mulberry',
        },
      });
    }
  }

  document.addEventListener('mulberry-shopify:loaded', async () => {
    if (typeof window.mulberryShop === 'undefined') {
      window.cpap.logError('mulberryShop is not defined.', {
        sentry__additionalData: {
          Mulberry: 'mulberryShop is not defined',
        },
      });
      return;
    }

    window.customModalVariant = 4;

    if (window.location.href.includes('/products/')) {
      mulberryInit();

      const addToCartForms = document.querySelectorAll('[data-type=add-to-cart-form]');

      addToCartForms.forEach((addToCartForm) => {
        addToCartForm.addEventListener('submit', () => {
          if (window.selectedWarranty && window.selectedWarranty != null) {
            window.mulberryReadyToAdd = true;
          }
        });
      });
    }

    if (window.location.href.includes('/cart')) {
      await window.mulberryShop.cart.init();
      await window.mulberryShop.cart.render();
      const checkInterval = setInterval(() => {
        if (document.body.querySelector('.mulberry-modal-overlay')) {
          console.log('Element with class mulberry-modal-overlay exists!');
          const modalOverlayNode = document.querySelector('.mulberry-modal-overlay');
          if (modalOverlayNode) {
            document.querySelector('.mulberry-modal-overlay').textContent = ` `;
          }
          clearInterval(checkInterval); // Stop the interval once the element is found
        }
      }, 100);
    }
    window.cpap.mulberry.removeAndSyncWarranties();
  });

  window.cpap.mulberry.removeAndSyncWarranties = async () => {
    try {
      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
      });

      const cart = await cartResponse.json();
      const detachedWarrantyCart = await window.mulberryShop.removeDetachedWarranty(cart); // Remove Warranties First
      const syncedQuantitiesCart = await window.mulberryShop.cart.syncQuantities(
        detachedWarrantyCart
      ); // Sync Quantities Second

      if (
        window.location.href.includes('/cart') &&
        String(document.querySelector('.cpap-cart-total').dataset.totalPrice) !==
          String(syncedQuantitiesCart.total_price)
      ) {
        // Convert to currency format
        const amount = syncedQuantitiesCart.total_price;
        const formattedAmount = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(amount / 100); // divide by 100 to get the correct decimal value

        const cartTotalNode = document.querySelector('.cpap-cart-total');

        if (cartTotalNode) {
          cartTotalNode.dataset.totalPrice = amount;
          cartTotalNode.innerText = formattedAmount;
        }

        window.mulberryShop.cart.render({ refresh: true });
        syncedQuantitiesCart.items.forEach((item, index) => {
          document.querySelector(`#CartItem-${index + 1} #Quantity-${index + 1}`).value =
            item.quantity;
        });
        setTimeout(() => {
          const modalOverlayNode = document.querySelector('.mulberry-modal-overlay');
          if (modalOverlayNode) {
            modalOverlayNode.textContent = ` `;
          }
        }, 800);
      }
    } catch (error) {
      window.cpap.logError(error, {
        sentry__additionalData: {
          Mulberry: 'Error syncing warranties',
        },
      });
    }
  };

  // 👇 Custom code to disable linking directly to the Mulberry PDPs from Rebuy Smart Cart
  const disableMulberryLinksInRebuySmartcart = async () => {
    const rebuyCartItemNodes = document.querySelectorAll('.rebuy-cart__flyout-item');
    let isAvailable = false;

    if (rebuyCartItemNodes) {
      for (const rebuyCartItemNode of rebuyCartItemNodes) {
        const headingLinkNode = rebuyCartItemNode.querySelector('[role="heading"]');
        const isMulberryProduct = headingLinkNode
          ?.getAttribute('alt')
          ?.toLowerCase()
          ?.includes('mulberry');

        if (isMulberryProduct) {
          // Hide the element by setting its display property to 'none'
          rebuyCartItemNode.style.display = 'none';
          currentURL = [
            headingLinkNode,
            rebuyCartItemNode.querySelector('.rebuy-cart__flyout-item-media a'),
          ].forEach((node) => {
            node?.removeAttribute('href');
            node?.setAttribute('aria-disabled', 'true');
          });
        } else {
          if (window.mulberryShop) {
            const productData = await window.mulberryShop.getProductData(
              headingLinkNode.getAttribute('href')
            );
            if (productData && productData?.product) {
              const targetElement = rebuyCartItemNode.querySelector(
                '.rebuy-cart__flyout-item-media'
              );
              const { product } = productData;

              // Check if warranty-details is already available after the target element
              const warrantyDetails = targetElement.nextElementSibling;
              if (!warrantyDetails || warrantyDetails.tagName !== 'WARRANTY-DETAILS') {
                // Create the warranty-details element
                const warrantyDetailsElement = document.createElement('warranty-details');
                warrantyDetailsElement.setAttribute('data-variant-id', product.variants[0].id);
                warrantyDetailsElement.setAttribute('style', 'padding-left:98px');
                // Insert the warranty-details element after the target element
                targetElement.insertAdjacentElement('afterend', warrantyDetailsElement);
              }

              isAvailable = true;
            }
          }
        }
      }

      if (window.mulberryShop && window.mulberryShop?.cart && isAvailable) {
        await window.mulberryShop.cart.init();
        await window.mulberryShop.cart.render();
        setTimeout(() => {
          const modalOverlayNode = document.querySelector('.mulberry-modal-overlay');
          if (modalOverlayNode) {
            modalOverlayNode.textContent = ` `;
          }
        }, 800);
      }
    }
  };

  setTimeout(disableMulberryLinksInRebuySmartcart, 800);
  document.addEventListener('rebuy:cart.ready', () => {
    setTimeout(disableMulberryLinksInRebuySmartcart, 800);
  });
  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(disableMulberryLinksInRebuySmartcart, 800);
  });

  document.addEventListener('mulberry-shopify:warranty-added', () => {
    const modalOverlayNode = document.querySelector('.mulberry-modal-overlay');
    if (modalOverlayNode) {
      modalOverlayNode.textContent = `  `; // Empty the modal content
    }
    setTimeout(async () => {
      await window.cpap.mulberry.removeAndSyncWarranties();
      if (window.location.href.includes('/cart')) {
        await window.mulberryShop.cart.init();
        await window.mulberryShop.cart.render();
      }
    }, 800);
  });

  const urlChangeEvent = new Event('cpap-mulberry-shopify:url-change');

  // Next, monkey patch the history methods to dispatch custom Mulberry event
  ((history) => {
    const pushState = history.pushState;
    const replaceState = history.replaceState;

    history.pushState = function (state) {
      pushState.apply(history, arguments);
      window.dispatchEvent(urlChangeEvent);
    };

    history.replaceState = function (state) {
      replaceState.apply(history, arguments);
      window.dispatchEvent(urlChangeEvent);
    };
  })(window.history);

  async function checkVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (product?.variants && variantId) {
      window.mulberryShop.selectedVariantId = variantId;
      window.selectedVariant = product.variants.find(({ id }) => String(id) == String(variantId));

      try {
        offers = await mulberry.core.getWarrantyOffer({
          id: window.selectedVariant.id,
          title: product.title,
          price: window.selectedVariant.price,
          detail: product,
        });

        if (offers) {
          try {
            mulberry.modal.updateOffer(offers);
          } catch (error) {
            window.cpap.logError(error, {
              sentry__additionalData: {
                Mulberry: 'Error updating warranty offers',
              },
            });
          }
        } else {
          window.cpap.logError('No offers returned from getWarrantyOffer.', {
            sentry__additionalData: {
              Mulberry: 'No offers returned from getWarrantyOffer.',
            },
          });
        }
      } catch (error) {
        window.cpap.logError(error, {
          sentry__additionalData: {
            Mulberry: 'Error fetching warranty offers',
          },
        });
      }
    }
  }

  window.addEventListener('cpap-mulberry-shopify:url-change', checkVariant);

  document.addEventListener('mulberry-shopify:loaded', async () => {
    function setupFetchListeners() {
      const { fetch: origFetch } = window;
      window.fetch = async (...args) => {
        const response = await origFetch(...args);
        let requestUrl = args[0];
        if (
          requestUrl.includes('cart/change') ||
          requestUrl.includes('cart/add') ||
          requestUrl.includes('cart/update')
        ) {
          response
            .clone()
            .json()
            .then(async (body) => {
              if (requestUrl.includes('cart/change')) {
                fetchChangeCustomEvent = new CustomEvent('fetch:cart-change');
                document.dispatchEvent(fetchChangeCustomEvent);
              }
              if (requestUrl.includes('cart/add')) {
                fetchChangeCustomEvent = new CustomEvent('fetch:cart-add', {
                  detail: body,
                });
                document.dispatchEvent(fetchChangeCustomEvent);
              }
              if (requestUrl.includes('cart.php') && !requestUrl.includes('cart/update')) {
                fetchCartCustomEvent = new CustomEvent('fetch:cart-page');
                document.dispatchEvent(fetchCartCustomEvent);
              }
            })
            .catch((err) => {
              console.error(err);

              window.cpap.logError('Error loading Mulberry for Shopify.', {
                sentry__additionalData: {
                  Mulberry: 'Error loading Mulberry for Shopify.',
                },
              });
            });
        }
        return response;
      };
    }
    setupFetchListeners();
    window.onload = async function () {
      if (window.location.href.includes('/cart')) {
        await window.mulberryShop.cart.init();
        await window.mulberryShop.cart.render();
      }
      setTimeout(() => {
        const modalOverlayNode = document.querySelector('.mulberry-modal-overlay');
        if (modalOverlayNode) {
          modalOverlayNode.textContent = `  `; // Empty the modal content
        }
      }, 1000);
    };
  });

  document.addEventListener('fetch:cart-add', async (body) => {
    if (
      window.selectedWarranty &&
      window.selectedWarranty != null &&
      window.mulberryReadyToAdd === true &&
      body.detail.vendor != 'Mulberry'
    ) {
      window.mulberryReadyToAdd = false;
      const result = await window.mulberryShop.getWarrantyVariant(window.selectedWarranty.offer);
      await window.mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          title: window.productForWarranty.title,
          price: window.selectedVariant.price,
          variantId: window.selectedVariant.id,
        },
        window.selectedWarranty.offer
      );
    }
  });
  document.addEventListener('fetch:cart-change', async (body) => {
    await window.cpap.mulberry.removeAndSyncWarranties();
    setTimeout(async () => {
      if (window.location.href.includes('/cart')) {
        await window.mulberryShop.cart.init();
        await window.mulberryShop.cart.render();
      }
    }, 1000);
  });
});
